import React from 'react';

function EqualizeComponent() {
    return <div>EqualizeComponent</div>;
}

export default EqualizeComponent;
